import { useState, useEffect } from 'react';
import { child, ref, update, onValue, get, query, getDatabase, remove } from 'firebase/database';
import { auth, database } from '../config';

export const sendInvitation = async (
  user: { uid: string; email: string },
  board: { boardId: string; boardName: string }
) => {
  const databaseRef = ref(database);
  try {
    await update(
      child(databaseRef, `/private/${auth.currentUser?.uid}/boards/${board.boardId}/invited`),
      { [user.uid]: user.email }
    );
    await update(child(databaseRef, `/invitations/${user.uid}`), {
      [board.boardId]: board.boardName,
    });
  } catch (e) {
    throw new Error();
  }
};

export const removeInvitation = async (userId: string, boardId: string) => {
  const databaseRef = ref(database);
  try {
    await remove(
      child(databaseRef, `/private/${auth.currentUser?.uid}/boards/${boardId}/invited/${userId}`)
    );
    await remove(child(databaseRef, `/invitations/${userId}/${boardId}`));
  } catch (e) {
    throw new Error();
  }
};

export const useInvitations = () => {
  const databaseRef = ref(database);
  const [invitations, setInvitations] = useState<{ id: string; title: string }[]>([]);
  const [objects, setObjects] = useState<Record<string, any>>({});
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    onValue(child(databaseRef, `/invitations/${auth.currentUser?.uid}`), (snap) => {
      const objects = snap?.val();
      const invitationsRes = objects
        ? Object.keys(objects)
            .filter((key) => key !== 'email' && key !== 'uid')
            .map((key) => {
              return {
                title: objects[key],
                id: key,
              };
            })
        : [];
      setInvitations(invitationsRes);
      setObjects(objects);
      setLoading(false);
    });
  }, []);

  return { invitations, loading, objects };
};

export const useCustomInvitations = (uid: string) => {
  const [invitations, setInvitations] = useState<{ id: string; title: string }[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const getReports = async () => {
    setLoading(true);
    setInvitations([]);
    const db = getDatabase();
    const invQuery = query(ref(db, `/invitations/${uid}`));
    try {
      const res = await get(invQuery);
      setLoading(false);
      return res.val();
    } catch (e) {
      console.log(e);
      setLoading(false);
      throw new Error();
    }
  };

  useEffect(() => {
    getReports().then((res) => {
      const objects = res;
      const invitationsRes = res
        ? Object.keys(objects)
            .filter((key) => key !== 'email' && key !== 'uid')
            .map((key) => {
              return {
                title: objects[key],
                id: key,
              };
            })
        : [];
      setInvitations(invitationsRes);
    });
  }, [uid]);

  return { invitations, loading };
};
